/**
 * Resolve media paths for the Xattir site.
 * Prefer local mirrors under `public/` (ADR-005 assets mirrored).
 * Pass an absolute http(s) URL through unchanged.
 */
export function asset(path: string) {
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return path.startsWith("/") ? path : `/${path}`;
}
